angular.module("bccNgApp").controller('EventSearchController', ["$scope", function ($scope) {

    $scope.categories = [];
    $scope.venues = [];
    $scope.loading = true;
    $scope.events = [];
    $scope.resultCount = 0;
    $scope.page = 1;
    $scope.pages = [];
    $scope.venue = "";
    $scope.category = "";
    $scope.keywords = "";

    $scope.init = function (keywords) {
        $scope.keywords = keywords;
        getCategories();
        getVenues();
        getEvents();
    }

    $scope.setVenue = function (e, venueId) {
        $scope.venue = venueId;
        getEvents();
    }

    $scope.setCategory = function (e, categoryId) {
        $scope.category = categoryId;
        getEvents();
    }

    $scope.changePage = function (e, page) {
        e.preventDefault();
        if (page <= $scope.pages.length && page > 0) {
            if (!isNaN(page)) {
                $scope.page = page;
                getEvents(false);
            }
        }
    }

    function getCategories() {
        var url = "/api/sitecore/bccevents/categories";
        $.get(url, function (data) {
            $scope.categories = data;
            $scope.$apply();
        }).fail(function () {
            alert("Error getting categories.")
        });
    }

    function getVenues() {
        var url = "/api/sitecore/bccevents/venues";
        $.get(url, function (data) {
            $scope.venues = data;
            $scope.$apply();
        }).fail(function () {
            alert("Error getting venues.")
        });
    }

    function getEvents(resetPage = true) {
        if (resetPage) {
            $scope.page = 1;
        }
        $scope.loading = true;
        var url = buildUrl();
        $.get(url, function (data) {
            $scope.events = data.Results;
            $scope.resultCount = data.ResultCount;
            $scope.loading = false;
            var pages = Math.ceil(data.ResultCount / data.Criteria.PageSize);
            $scope.pages = [];
            $scope.pages = buildPages($scope.page, pages);
            $scope.$apply();
        }).fail(function () {
            alert("Error getting events.")
        });
    }

    function buildUrl() {
        var url = "/api/sitecore/bccevents/search?pg=";
        url += $scope.page;
        if ($scope.category) {
            url += "&c=" + $scope.category;
        }
        if ($scope.venue) {
            url += "&v=" + $scope.venue;
        }
        if ($scope.keywords) {
            url += "&q=" + $scope.keywords;
        }
        return url;
    }

    function buildPages(current, total) {
        var pages = [];
        if (total > 1) {
            var start = Math.max(1, current - 3);
            var end = Math.min(total, Math.max(current + 3, 7));
            if (current > 3) {
                pages.push(1);
                pages.push("\t...");
            }
            for (var i = start; i < end; i++) {
                pages.push(i);
            }
            if (end < total) {
                pages.push("...\t");
                pages.push(total);
            }
        }
        return pages;
    }
}]);